import { httpClientBanking } from '~/domains/banking/shared/infra/http-client-banking'
import { useQueryRequest } from '~/ui/hooks/utils'
import { type UseQueryRequestOptions } from '~/ui/hooks/utils/service/use-query-request'

type MovementStatus = 'success' | 'failed' | 'processing'

async function fetchMovementStatus({
  accountId,
  bucketId,
  movementIds
}: {
  accountId: string
  bucketId: string
  movementIds?: string[]
}) {
  const { data } = await httpClientBanking<{ movementIds: Record<string, MovementStatus> }>({
    url: `/investments/accounts/${accountId}/buckets/${bucketId}/movements/status`,
    method: 'POST',
    data: { movement_ids: movementIds ? movementIds : [] }
  })
  return data
}

export function useFetchMovementStatus({
  accountId,
  bucketId,
  movementIds,
  config
}: {
  accountId: string
  bucketId: string
  movementIds?: string[]
  config?: UseQueryRequestOptions<{ movementIds: Record<string, MovementStatus> }, unknown, true>
}) {
  const {
    data: movementStatusData,
    isLoading: isMovementStatusLoading,
    isError: isMovementStatusError,
    isSuccess: isMovementStatusSuccess
  } = useQueryRequest<{ movementIds: Record<string, MovementStatus> }, unknown, true>(
    ['useFetchMovementStatus', accountId, bucketId, movementIds?.join(';')],
    () => fetchMovementStatus({ accountId, bucketId, movementIds }),
    config
  )

  return {
    movementStatusData,
    isMovementStatusLoading,
    isMovementStatusError,
    isMovementStatusSuccess
  }
}
